import { getLang } from '@lingoda/env';

export * from './buildQueryString';
export * from './buildUrl';
export * from './getAppByDomain';
export * from './getBaseUri';
export * from './getCurrentPath';
export * from './getHost';
export * from './getNewLangLocation';
export * from './getPath';
export * from './getQueryParam';
export * from './getQueryParams';
export * from './getRawPath';
export * from './getSchema';
export * from './getSchemaHost';
export * from './getTopLevelDomain';
export * from './getUrl';
export * from './isAbsolute';
export * from './isInTeacherDomain';
export * from './isLocalHost';
export * from './queryParamsDecoder';
export { toMarketingUrl } from './replaceDomain';
export * from './resolveProtocol';

export enum SupportUrlType {
    // student urls
    Home = 'home',
    Apple = 'apple',
    Facebook = 'facebook',
    Class = 'class',
    CancelClass = 'cancelClass',
    Lingobites = 'lingobites',
    Recording = 'recording',
    TechnicalRequirements = 'technicalRequirements',
    PersonalizedClassFeedbackFromTeacher = 'personalizedClassFeedbackFromTeacher',
    ClassroomStudentFAQ = 'classroomStudentFAQ',
    ClassroomStudentTroubleshoot = 'classroomStudentTroubleshoot',
    // teacher urls
    TeacherLogClasses = 'teacherLogClasses',
    TeacherLogClassesB2G = 'teacherLogClassesB2G',
    TeacherCancelClass = 'teacherCancelClass',
}

const elevioBase = 'https://lingoda-students.elevio.help';

export const getSupportUrl = (type: SupportUrlType) =>
    ({
        // student urls
        home: elevioBase,
        apple: `${elevioBase}/${getLang()}/articles/256`,
        facebook: `${elevioBase}/${getLang()}/articles/247`,
        class: `${elevioBase}/${getLang()}/articles/157`,
        cancelClass: `${elevioBase}/${getLang()}/articles/230`,
        lingobites: `${elevioBase}/${getLang()}/articles/349-lingobites-unsere-neue-uebungsfunktion`,
        recording: `${elevioBase}/${getLang()}/articles/153-are-the-chat-notes-from-my-class-saved`,
        technicalRequirements: `${elevioBase}/${getLang()}/articles/175`,
        personalizedClassFeedbackFromTeacher: `${elevioBase}/${getLang()}/articles/305-personalised-class-feedback`,
        classroomStudentFAQ: `${elevioBase}/${getLang()}/articles/395-lingoda-classroom-faq`,
        classroomStudentTroubleshoot: `${elevioBase}/${getLang()}/articles/372-lingoda-classroom-troubleshooting`,
        // teacher urls
        teacherLogClasses:
            'https://lingodateachers.bettermode.io/lingoda-classes-new-az634gna/post/how-to-log-your-classes-Zm6e11snK5UiV05',
        teacherLogClassesB2G:
            'https://lingodateachers.bettermode.io/health-feedback-ttedxwrn/post/class-log-feedback-in-health-stunden-whyk6YHVOGXNJEo',
        teacherCancelClass:
            'https://lingodateachers.bettermode.io/lingoda-classes-new-az634gna/post/cancelling-classes-FKJ7DyaqvkPLMG6',
    })[type];
